import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from '../../../../shared/i18n';
import { autoRewardRulesKidApi } from '../../api/autoRewardRules';

const RuleCard = ({ rule, t }) => {
  const weekdayLabels =
    rule.weekdays?.map((d) => t(`auto_reward_rules.weekdays_short.${d}`)) || [];

  return (
    <div className="card mb-3" data-testid={`kid-auto-reward-rule-${rule.id}`}>
      <div className="card-body">
        <div className="d-flex align-items-start gap-3">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
            style={{
              width: '40px',
              height: '40px',
              background: 'linear-gradient(135deg, #fde68a 0%, #f59e0b 100%)'
            }}
          >
            <i className="bi bi-gift-fill text-white" style={{ fontSize: '20px' }}></i>
          </div>
          <div className="flex-grow-1 min-w-0">
            <div className="fw-bold mb-1">
              {t(`auto_reward_rules.rule_type.${rule.rule_type}`)}
            </div>
            <div
              className="text-muted small mb-1"
              data-testid={`kid-auto-reward-rule-reward-${rule.id}`}
            >
              {t('auto_reward_rules.row.reward', {
                amount: rule.amount,
                currency: rule.family_currency?.name || ''
              })}
            </div>
            {rule.monitored_activity && (
              <div className="text-muted small">
                {t('auto_reward_rules.row.activity', {
                  name: rule.monitored_activity.name
                })}
              </div>
            )}
            {weekdayLabels.length > 0 && (
              <div className="text-muted small">
                {t('auto_reward_rules.row.weekdays', {
                  days: weekdayLabels.join(', ')
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const AutoRewardRulesPage = () => {
  const { t } = useTranslation();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    autoRewardRulesKidApi
      .list()
      .then((res) => {
        setRules(res.data?.auto_reward_rules || []);
      })
      .catch(() => setError(t('common.error')))
      .finally(() => setLoading(false));
  }, [t]);

  return (
    <div className="bg-light">
      <div
        className="container py-4"
        data-testid="kid-auto-reward-rules-page"
      >
        <div className="mb-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
          <h2 className="h3 fw-bold mb-0">
            {t('auto_reward_rules.kid.page_title')}
          </h2>
          <Link to="/wallet" className="btn btn-outline-secondary btn-sm">
            <i className="bi bi-arrow-left me-1"></i>
            {t('common.back')}
          </Link>
        </div>

        <p className="text-muted">{t('auto_reward_rules.kid.description')}</p>

        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('common.loading')}</span>
            </div>
          </div>
        )}

        {!loading && error && <div className="alert alert-danger">{error}</div>}

        {!loading && !error && rules.length === 0 && (
          <p
            className="text-muted"
            data-testid="kid-auto-reward-rules-empty"
          >
            {t('auto_reward_rules.kid.empty')}
          </p>
        )}

        {!loading && !error &&
          rules.map((rule) => <RuleCard key={rule.id} rule={rule} t={t} />)}
      </div>
    </div>
  );
};

export default AutoRewardRulesPage;
